import { useRef as w, useCallback as b, useEffect as I } from "react";
const R = [
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#673ab7",
  "#3f51b5",
  "#2196f3",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#8bc34a",
  "#cddc39",
  "#ffeb3b",
  "#ffc107",
  "#ff9800",
  "#ff5722",
  "#795548",
  "#607d8b"
], A = {
  display: "block",
  position: "absolute",
  pointerEvents: "none",
  inset: 0,
  width: "100%",
  height: "100%"
}, S = (e) => {
  const n = Object.values(e).reduce((a, r) => a + r, 0);
  let t = Math.random();
  for (let [a, r] of Object.entries(e)) {
    if (t < r / n)
      return a;
    t -= r / n;
  }
}, F = (e) => {
  const n = w(), t = b((a) => {
    e(a), n.current = requestAnimationFrame(t);
  }, [e]);
  I(() => (n.current = requestAnimationFrame(t), () => cancelAnimationFrame(n.current)), [t]);
}, z = (e) => new Promise((n, t) => {
  const a = new Image();
  a.onload = () => n(a), a.onerror = t, a.src = e;
}), P = (e) => {
  if (!Array.isArray(e))
    return e;
  const [n, t] = e;
  return t == null ? n : n + Math.random() * (t - n);
}, x = ({ ctx: e, p: n }) => {
  e.beginPath(), e.lineCap = "butt", e.lineWidth = n.diameter, e.strokeStyle = n.color, e.moveTo(0, 0), e.lineTo(0, n.diameter / 2), e.stroke();
}, O = ({ ctx: e, p: n }) => {
  e.fillStyle = n.color, e.beginPath(), e.ellipse(
    0,
    0,
    n.diameter / 2.5,
    n.diameter / 2.5,
    0,
    0,
    Math.PI * 2
  ), e.fill();
}, k = ({
  forwardPortion: e = 0.5,
  backwardPortion: n = 1,
  horizontalShiftPortion: t = 0.4,
  verticalShiftPortion: a = 0.25,
  innerControlPortion: r = 0.6,
  outerControlPortion: i = 1
} = {}) => ({ ctx: c, p: f }) => {
  const s = f.diameter / 2, h = s * t, l = s * r, d = s * i, m = s * e, o = s * n, u = s - s * a, y = -s + s * a;
  c.fillStyle = f.color, c.beginPath(), c.moveTo(m, y), c.bezierCurveTo(
    // curve to bottom right corner (front curve)
    -h,
    -l,
    // control1: top left corner
    -h,
    l,
    // control2: bottom left corner
    m,
    u
  ), c.bezierCurveTo(
    // curve to top right corner (back curve)
    -o,
    d,
    // control1: bottom left corner
    -o,
    -d,
    // control2: top left corner
    m,
    y
  ), c.fill();
}, B = (e) => ({ ctx: n, p: t }) => {
  n.drawImage(
    e,
    -t.diameter / 2,
    -t.diameter / 2,
    t.diameter,
    t.diameter
  );
}, g = ({
  numPoints: e = 3,
  spiked: n = !1,
  spikedPortion: t = 0.5,
  fill: a = !0,
  startAngle: r = Math.PI / 4
} = {}) => ({ ctx: i, p: c }) => {
  const f = Math.PI * 2 / e, s = 1, [h, l] = [0, 0];
  i.beginPath(), i.fillStyle = c.color, i.lineWidth = c.diameter / 5, i.strokeStyle = c.color;
  for (let d = 0; d < e + 1; d++) {
    const m = r + d % e * f, o = h + Math.cos(m) * c.diameter / 2 * s, u = l + Math.sin(m) * c.diameter / 2 * s;
    if (n) {
      const y = r + (d % e - 0.5) * f, v = h + t * Math.cos(y) * c.diameter / 2 * s, M = l + t * Math.sin(y) * c.diameter / 2 * s;
      i.lineTo(v, M);
    }
    d === 0 ? i.moveTo(o, u) : i.lineTo(o, u);
  }
  a ? i.fill() : i.stroke();
}, L = {
  line: x,
  circle: O,
  moon: k(),
  triangle: g({ numPoints: 3 }),
  square: g({ numPoints: 4 }),
  pentagon: g({ numPoints: 5 }),
  hexagon: g({ numPoints: 6 }),
  heptagon: g({ numPoints: 7 }),
  octagon: g({ numPoints: 8 }),
  diamond: g({ numPoints: 4, spiked: !0 }),
  star: g({ numPoints: 5, spiked: !0 }),
  hexagram: g({ numPoints: 6, spiked: !0 })
}, E = {
  gravity: 9.8,
  wind: 0,
  speed: 1,
  killDistance: 100,
  initialVelocity: [0, -3],
  initialVelocitySpread: [5, 7],
  diameter: [10, 30],
  twirl: [0, 0.2],
  initialAngle: [0, 360],
  angleIncrement: [-10, 10],
  initialFlip: [0, 360],
  flipIncrement: [-10, 10],
  rotationVelocityCoefficient: 0.8,
  colors: R,
  shapeFunctions: L,
  shapeWeights: {
    triangle: 1,
    circle: 1,
    star: 1,
    square: 1
  },
  count: 75,
  duration: 0,
  spawnLocation: "area",
  spawnGap: 0
}, V = (e, n, t, a, r) => {
  const [i, c] = [n.x - t.left, n.y - t.top];
  e.setTransform(
    a.translate(i, c).rotate(n.angle).scale(1, Math.sin((n.flip + 90) * (Math.PI / 180))).translate(-n.twirl * n.diameter, -n.twirl * n.diameter)
  ), r[n.shape]({ p: n, ctx: e }), e.setTransform(1, 0, 0, 1, 0, 0);
}, D = (e, n, t, a, r) => {
  if (n < e.delayUntil)
    return { particle: e, visible: !1 };
  const i = r.killDistance / window.devicePixelRatio;
  if (e.x < -i || e.x > t + i || e.y < -i || e.y > a + i)
    return { particle: void 0, visible: !1 };
  const c = e.flipIncrement * (r.rotationVelocityCoefficient ? Math.min(Math.max(e.vy, e.vx), 2) * r.rotationVelocityCoefficient : 1);
  return { particle: {
    ...e,
    vy: e.vy + r.gravity / 100 * r.speed,
    vx: e.vx + r.wind * r.speed,
    x: e.x + e.vx * r.speed,
    y: e.y + e.vy * r.speed,
    flip: e.flip + c * r.speed,
    angle: e.angle + e.angleIncrement * r.speed
  }, visible: !0 };
}, U = (e, n, t) => {
  const { left: a, top: r, width: i, height: c } = e.getBoundingClientRect(), [f, s] = [a + i / 2, r + c / 2], [h, l] = t.initialVelocity, [d, m] = t.initialVelocitySpread;
  let [o, u] = [0, 0];
  t.spawnLocation === "area" ? [o, u] = [a + Math.random() * i, r + Math.random() * c] : t.spawnLocation === "edges" ? ([o, u] = [a + Math.random() * i, r + Math.random() * c], Math.random() < 0.5 ? o = o < f ? a : a + i : u = u < s ? r : r + c) : t.spawnLocation === "corners" && ([o, u] = [a + Math.random() * i, r + Math.random() * c], o = o < f ? a : a + i, u = u < s ? r : r + c);
  const y = Math.atan2(u - s, o - f), [v, M] = [Math.cos(y), Math.sin(y)];
  o += v * t.spawnGap, u += M * t.spawnGap;
  const C = v * Math.random() * d + h, T = M * Math.random() * m + l;
  return {
    x: o,
    y: u,
    vx: C,
    vy: T,
    delayUntil: n + Math.random() * t.duration,
    diameter: P(t.diameter),
    color: t.colors[Math.random() * t.colors.length | 0],
    shape: S(t.shapeWeights),
    twirl: P(t.twirl),
    flip: P(t.initialFlip),
    flipIncrement: P(t.flipIncrement),
    angle: P(t.initialAngle),
    angleIncrement: P(t.angleIncrement)
  };
}, N = (e = {}) => {
  const n = { ...E, ...e }, t = w([]), a = w(0), r = w(), i = w(), c = w(), f = w(), s = b(async (l = {}) => {
    var o;
    const d = ((o = l.sourceRef) == null ? void 0 : o.current) ?? document.activeElement ?? document.body, m = { ...n, ...l };
    t.current = [
      ...t.current,
      ...Array.from({ length: m.count }, () => U(
        d,
        a.current,
        m
      ))
    ];
  }, [n]), h = b(() => {
    if (r.current) {
      const l = r.current.getBoundingClientRect(), { width: d, height: m } = l;
      i.current = l;
      const o = window.devicePixelRatio;
      r.current.width = Math.floor(d * o), r.current.height = Math.floor(m * o), typeof window < "u" && (f.current = new DOMMatrixReadOnly().scale(o));
    }
  }, []);
  return I(() => {
    if (r.current) {
      c.current = r.current.getContext("2d"), h();
      const l = new ResizeObserver(h);
      return l.observe(r.current), () => l.disconnect();
    }
  }, [r.current]), F((l) => {
    a.current = l;
    const d = c.current;
    if (d && i.current && r.current) {
      const { width: m, height: o } = r.current;
      d.clearRect(0, 0, m, o), t.current = t.current.reduce((u, y) => {
        const { particle: v, visible: M } = D(y, l, m, o, n);
        return v ? (M && f.current && V(
          d,
          v,
          i.current,
          f.current,
          n.shapeFunctions
        ), [...u, v]) : u;
      }, []);
    }
  }), {
    createConfetti: s,
    canvasProps: {
      ref: r,
      style: A
    }
  };
};
export {
  L as DEFAULT_SHAPE_FUNCTIONS,
  O as drawCircleParticle,
  k as drawCrescentParticle,
  B as drawImageParticle,
  x as drawLineParticle,
  g as drawRegularPolygonParticle,
  z as loadImage,
  N as useConfetti
};
